import { FACTORENABLE, GETCITIES, GETSTATE, ISAUTH, REFRESH_MENU, LOGIN, LOGIN_AGAIN, LOGOUT, LOGOUTUSER, VERIFYOTP } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const logIn = (payload) => {
  return apiInstance.post(LOGIN, payload);
};
export const logOutUser = (payload) => {
  return apiInstance.post(LOGOUTUSER, payload);
};

export const getState = (payload) => {
  return apiInstance.post(GETSTATE, payload);
};

export const getCities = (payload) => {
  return apiInstance.post(GETCITIES, payload);
};

export const verifyOtp = (payload) => {
  return apiInstance.post(VERIFYOTP, payload);
};

export const factorEnable = (payload) => {
  return apiInstance.post(FACTORENABLE, payload);
};

export const checkAuthStatus = () => {
  return apiInstance.get(`${ISAUTH}`);
};

export const logInAgain = (payload) => {
  return apiInstance.post(LOGIN_AGAIN, payload);
};

export const logOut = (payload) => {
  return apiInstance.post(LOGOUT, payload);
};

export const refreshMenu = () => {
  return apiInstance.get(REFRESH_MENU);
};
